import React from 'react'
import Categorias from '../components/Categorias'

const categorias = () => {
  return (
    <Categorias />
  )
}

export default categorias